import {
  FacilityFlowCoreModulesPlanningEntitiesTimeClockEventType as TimeClockEventTypeEnum,
  FacilityFlowCoreModulesPlanningEntitiesWorkLocation as WorkLocationEnum,
} from '@/api/generated/models';
import type { WorkLocation } from '@/store/useTimeclockStore';

/** The choices of "Homeoffice oder Büro?", with their `timeclock:workLocation.*` key. */
export const WORK_LOCATIONS: { location: WorkLocation; key: string }[] = [
  { location: WorkLocationEnum.NUMBER_1, key: 'office' },
  { location: WorkLocationEnum.NUMBER_2, key: 'homeOffice' },
];

interface StretchEvent {
  eventType?: number | null;
  workLocation?: WorkLocation | null;
}

/**
 * Work location of the stretch each event belongs to, for one day's events in chronological
 * order. Only clock-ins store it; every later event carries the latest clock-in's value. Events
 * before the first clock-in get null.
 */
export function stretchLocations(ordered: readonly StretchEvent[]): (WorkLocation | null)[] {
  let current: WorkLocation | null = null;
  return ordered.map((evt) => {
    if (evt.eventType === TimeClockEventTypeEnum.NUMBER_1) current = evt.workLocation ?? null;
    return current;
  });
}

/**
 * Same as stretchLocations for rows edited in a form, ordered by their "HH:mm" time value. Rows
 * without a time yet sort first, so only a clock-in among them has a location.
 */
export function stretchLocationsByTime<T extends StretchEvent & { timeValue: string }>(
  rows: readonly T[],
): Map<T, WorkLocation | null> {
  const ordered = [...rows].sort((a, b) => a.timeValue.localeCompare(b.timeValue));
  const locations = stretchLocations(ordered);
  return new Map(ordered.map((row, i) => [row, locations[i]]));
}

export function isHomeOffice(location: WorkLocation | null | undefined): boolean {
  return location === WorkLocationEnum.NUMBER_2;
}
